

































































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import AnimatedInput from "@/components/AnimatedInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import Browsercheck from "@/components/Browsercheck.vue";
import {Action, State} from "vuex-class";
import Upload from "@/models/Upload";
import Letterbox from "@/models/Letterbox";
import UploadListItem from "@/components/UploadListItem.vue";
import LetterboxListItem from "@/components/LetterboxListItem.vue";
import User from "@/models/User";
import BillingEvent from "@/models/BillingEvent";
import dayjs from "@/util/dayjs";
import { AxiosError } from 'axios';
import {Modal} from "bootstrap-vue";
import AdminAdapter from "@/adapters/admin";
import Address from "@/models/Address";
import countries from "@/util/countries";
import Invoice from "@/models/Invoice";

@Component({
  components: { AnimatedInput, LoadingButton, Browsercheck, UploadListItem, LetterboxListItem },
})
export default class Account extends Vue {

  @State(state => state.account.accountData) accountData!: User;
  @State(state => state.account.myUploads) myUploads!: Upload[];
  @State(state => state.account.myUploadsLoading) myUploadsLoading!: boolean;
  @State(state => state.account.myLetterboxes) myLetterboxes!: Letterbox[];
  @State(state => state.account.myLetterboxesLoading) myLetterboxesLoading!: boolean;
  @State(state => state.account.myBillingEvents) myBillingEvents!: BillingEvent[];
  @State(state => state.account.myBillingEventsLoading) myBillingEventsLoading!: boolean;
  @State(state => state.account.myInvoices) myInvoices!: Invoice[];
  @State(state => state.account.myInvoicesLoading) myInvoicesLoading!: boolean;

  @Action fetchMyUploads!: () => Promise<void>;
  @Action fetchMyLetterboxes!: () => Promise<void>;
  @Action changePassword!: (newPassword: string) => Promise<void>;
  @Action fetchMyBillingEvents!: () => Promise<void>;
  @Action fetchMyInvoices!: () => Promise<void>;

  countries = countries;
  adminAdapter: AdminAdapter = new AdminAdapter();

  address: Address | null = null;

  tabIdx: number = 1;
  tokenCount: number = 0;
  netAmount: number = 0;
  taxAmount: number = 0;
  subscriptionId: number = 0;

  newPassword: string = "";
  newPasswordRepeat: string = "";

  creditAmount: number = this.$store.state.account.accountData.organizations[0].autoRenewTokenCount || 25;
  creditAutoRenew: boolean = false;

  createNewUpload() {
    this.$router.push('/');
  }

  createNewLetterbox() {
    this.$router.push('/letterbox');
  }

  get avvState(): boolean {
    return this.$store.state.account.accountData.organizations[0].avvSigned || false;
  }

  get orgIdForAvv(): string {
    return "ORG-" + this.$store.state.account.accountData.organizations[0].id;
  }

  get autoRenewEnabled(): boolean {
    return this.$store.state.account.accountData.organizations[0].autoRenewTokenCount > 0;
  }

  get showLetterboxes(): boolean {
    return this.tabIdx === 0;
  }

  get showUploads(): boolean {
    return this.tabIdx === 1;
  }

  get showAccount(): boolean {
    return this.tabIdx === 2;
  }

  get showUsage(): boolean {
    return this.tabIdx === 3;
  }

  get minAddCredit(): number {
    return Math.ceil(Math.max(this.currentBalance, 1) / 10) * 10;
  }

  get currentBalance(): number {
    let result = 0;
    for (const event of this.myBillingEvents) {
      result += event.tokenCount;
    }
    for (const invoice of this.myInvoices) {
      result -= invoice.tokenCount;
    }
    return result;
  }

  get nextPaymentDate(): string {
    const date = dayjs().endOf("month").add(1, 'second');
    return date.format('dddd, DD. MMMM YYYY');
  }

  get validateAddress(): boolean {
    return !!(this.address && this.address.email && this.address.givenName && this.address.familyName &&
        this.address.streetAddress && this.address.streetAddress2 && this.address.postalCode && this.address.city);
  }

  get eventsAndInvoices(): Array<BillingEvent | Invoice> {
    const eventsAndInvoices: Array<BillingEvent | Invoice> = [];
    eventsAndInvoices.push(...this.myBillingEvents);
    eventsAndInvoices.push(...this.myInvoices);
    eventsAndInvoices.sort((a, b) => a.created > b.created ? -1 : 1);
    return eventsAndInvoices;
  }

  getBillingEventActionText(event: BillingEvent | Invoice): string {
    if (event.hasOwnProperty('sourceType')) {
      if ((event as BillingEvent).action === "REFUND") {
        return "Gutschrift / Erstattung";
      } else if ((event as BillingEvent).sourceType === "TRANSFER") {
        if ((event as BillingEvent).action === "CREATE") {
          return "Link versendet";
        } else if ((event as BillingEvent).action === "CHANGE_EXPIRY") {
          return "Link verlängert";
        } else if ((event as BillingEvent).action === "STORE_FILE") {
          return "Upload in Briefkasten erhalten & aufbewahrt";
        } else if ((event as BillingEvent).action === "REFUND") {
          return "Rückerstattung";
        }
      } else if ((event as BillingEvent).sourceType === "RECEIVED_FILE") {
        return "Erhaltene Datei wurde aufbewahrt";
      } else if ((event as BillingEvent).sourceType === "SETTLEMENT") {
        return "Abrechnung";
      }
    } else {
      return "Aufladung";
    }
    return "Unbekannte Aktion. Bitte wende Dich sich an service@uniki.de";
  }

  getBillingEventFormattedDate(event: BillingEvent | Invoice): string {
    const date = dayjs(event.created);
    return date.format('dddd, DD. MMMM YYYY [um] HH:mm');
  }

  startEnableAutoRenew(): Promise<any> {
    const that = this;
    return that.adminAdapter.getSubscriptionDetails().then((data: any) => {
      that.subscriptionId = data.id;
      that.netAmount = data.netAmount;
      that.taxAmount = data.taxAmount;
      (this.$refs.enableAutoRenewModal as Modal).show();
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
      }
    });
  }

  startAddCredit(): Promise<any> {
    const that = this;
    return that.adminAdapter.getSubscriptionDetails().then((data: any) => {
      that.subscriptionId = data.id;
      that.netAmount = data.netAmount;
      that.taxAmount = data.taxAmount;
      (this.$refs.addCreditModal as Modal).show();
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
      }
    });
  }

  startChangePaymentData(): Promise<any> {
    const that = this;
    return that.adminAdapter.initiatePaymentDetailsChange().then((data: any) => {
      that.tokenCount = data.tokenCount;
      that.netAmount = data.netAmount;
      that.taxAmount = data.taxAmount;
      (this.$refs.changePaymentDataModal as Modal).show();
      that.$nextTick(() => {
        //@ts-ignore
        const novalnet: any = Novalnet;
        novalnet.setParam("nn_it", "inline");
        novalnet.setParam("txn_secret", data.transactionToken);
        novalnet.render('novalnet_payment_form');
      });
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
      }
    });
  }

  changeAutoRenew(): Promise<void> {
    const data = {
      subscriptionId: this.subscriptionId,
      tokenCount: 0,
      autoRenewTokenCount: this.creditAutoRenew ? this.creditAmount : 0,
    };
    return this.adminAdapter.addCreditAndSetAutoRenew(data).then(() => {
      (this.$refs.enableAutoRenewModal as Modal).hide();
      (this.$refs.disableAutoRenewModal as Modal).hide();
      this.$store.state.account.accountData.organizations[0].autoRenewTokenCount = data.autoRenewTokenCount;
      this.$toast.success("Einstellung gespeichert.");
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
      }
    });
  }

  addCredit(): Promise<void> {
    if (this.creditAmount >= this.minAddCredit) {
      const data = {
        subscriptionId: this.subscriptionId,
        tokenCount: this.creditAmount,
        autoRenewTokenCount: this.creditAutoRenew ? this.creditAmount : null,
      };
      return this.adminAdapter.addCreditAndSetAutoRenew(data).then(() => {
        this.$toast.success("Vielen Dank! Dein Guthaben wurde mit " + this.creditAmount + "Transfer-Einheiten aufgeladen.");
      }).catch((error: AxiosError) => {
        if (error.response && error.response.status === 429) {
          this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
        } else {
          this.$toast.error("Ein Fehler ist aufgetreten. Bitte versuche es später erneut.");
        }
      }).finally(() => {
        this.fetchMyInvoices();
        (this.$refs.addCreditModal as Modal).hide();
      });
    } else {
      this.$toast.error("Bitte lade mindestens " + this.minAddCredit + " Transfer-Einheiten auf, um den aktuellen Verbrauch auszugleichen.");
      return Promise.resolve();
    }
  }

  async askChangePassword() {
    if (this.newPassword !== this.newPasswordRepeat) {
      this.$toast.error("Passwörter stimmen nicht überein.");
      this.newPassword = "";
      this.newPasswordRepeat = "";
      return;
    }

    try {
      await this.changePassword(this.newPassword);
    } catch (e) {
      this.$toast.error("Passwort konnte nicht geändert werden");
    }
  }

  changeAddress(): Promise<any> {
    if (this.address) {
      return this.adminAdapter.changeBillingAddress(this.address).then(address => this.address = address);
    } else {
      return Promise.resolve();
    }
  }

  get fullUserName(): string {
    if (!this.accountData || !this.accountData.firstName) {
      return "";
    }

    return this.accountData.firstName + (this.accountData.lastName ? " " + this.accountData.lastName : "");
  }

  fetchAddress(): void {
    void this.adminAdapter.getBillingAddress().then(address => this.address = address);
  }

  created() {
    this.fetchMyLetterboxes();
    this.fetchMyUploads();
    this.fetchMyBillingEvents();
    this.fetchMyInvoices();
    this.fetchAddress();
  }

}
